import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Block className="landing-header-text">
          <Element type="h2" className="header-text1">{"Akbank Expat Banking Making Life Easier!"}</Element>
          <Element type="p" className="header-text2">{"•	Responsive service backed by unmatched know-how."}<br /><br />{"•	Manage your assets in multiple currencies."}<br /><br />{"•	Life with Wings credit card is now a unique experience."}</Element>
        </Block>
      </Block>
      <Image path={"./img/expatbanking/expat-banking.png"} className="landing-header-img" />
    </Block>
  )
}

export default LandingHeader
